import { useCallback, useContext, useState } from 'react';
import MenuOption from '~/constants/MenuOption';
import FacetDataContext from '~/contexts/FacetDataContext';
import Make from './Make';
import FilterDrawer from '../FilterDrawer';
import { CommonWrapper } from '../styles';
import WithClassName from '../WithClassName';
import WithExpandOnOpen from '../WithExpandOnOpen';

type OwnProps = WithClassName & WithExpandOnOpen;

function MakeModel({ className, expandOnOpen }: OwnProps) {
  const { facetData } = useContext(FacetDataContext);
  const makes = Object.values(facetData.makes ?? {});
  const expandSection = expandOnOpen === MenuOption.Make;
  const [show, setShow] = useState(expandSection);

  return (
    <FilterDrawer
      className={className}
      dataQa="facet-make-model"
      facetContent={makes}
      facetName="Make & Model"
      show={show}
      onToggle={useCallback(() => setShow(v => !v), [])}
      expandOnOpen={expandSection}
    >
      <CommonWrapper>
        {makes.map(({ key, count, models }) => (
          <Make key={key} count={count} make={key} models={models} />
        ))}
      </CommonWrapper>
    </FilterDrawer>
  );
}

export default MakeModel;
